import { s } from '../lib/style.js';

export function Faq({ v }) {
  return (
    <section id="faq" style={s("scroll-margin-top:80px;background:var(--ink);")}>
      <div
        style={s("max-width:1000px;margin:0 auto;padding:clamp(28px,3vw,44px) clamp(20px,4vw,28px) clamp(40px,5vw,64px);")}
      >
        <div style={s("text-align:center;max-width:660px;margin:0 auto;")}>
          <h2
            style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:clamp(30px,4vw,50px);line-height:1.08;letter-spacing:-0.03em;margin:0;color:var(--text);")}
          >
            Got questions?
            {' '}
            <span style={s(v.kwLight)}>
              We've got answers.
            </span>
          </h2>
          <p style={s("margin:18px 0 0;font-size:18px;line-height:1.6;color:var(--muted);")}>
            The things brand and data leaders actually ask before starting a partnership.
          </p>
        </div>
        <div style={s("margin-top:clamp(40px,5vw,62px);display:flex;flex-direction:column;")}>
          <div style={s("border-top:1px solid var(--line);")}>
            {' '}
            <button
              type="button"
              onClick={v.toggle1}
              style={s("width:100%;background:none;border:none;padding:26px 4px;display:flex;align-items:flex-start;gap:20px;text-align:left;cursor:pointer;")}
            >
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;color:var(--mint);padding-top:5px;min-width:20px;")}
              >
                1
              </span>
              {' '}
              <span
                style={s("flex:1;font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(17px,1.9vw,21px);letter-spacing:-0.02em;color:var(--text);")}
              >
                Isn't this just another dashboard?
              </span>
              {' '}
              <span style={s("font-size:22px;line-height:1;color:var(--mint);padding-top:2px;")}>
                {v.sign1}
              </span>
              {' '}
            </button>
            {' '}
            {v.open1 ? (
              <>
                <p
                  style={s("margin:0 4px 28px 44px;max-width:660px;font-size:17px;line-height:1.7;color:var(--muted);")}
                >
                  No. Dashboards show you numbers and stop there. BrandBase is an agentic layer that connects your sources, reconciles them, and produces the artifact — the business review, the insight readout, the recommendation — with the reasoning shown and every figure traceable back to source.
                </p>
              </>
            ) : null}
          </div>
          <div style={s("border-top:1px solid var(--line);")}>
            {' '}
            <button
              type="button"
              onClick={v.toggle2}
              style={s("width:100%;background:none;border:none;padding:26px 4px;display:flex;align-items:flex-start;gap:20px;text-align:left;cursor:pointer;")}
            >
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;color:var(--mint);padding-top:5px;min-width:20px;")}
              >
                2
              </span>
              {' '}
              <span
                style={s("flex:1;font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(17px,1.9vw,21px);letter-spacing:-0.02em;color:var(--text);")}
              >
                Do we have to replace our current stack?
              </span>
              {' '}
              <span style={s("font-size:22px;line-height:1;color:var(--mint);padding-top:2px;")}>
                {v.sign2}
              </span>
              {' '}
            </button>
            {' '}
            {v.open2 ? (
              <>
                <p
                  style={s("margin:0 4px 28px 44px;max-width:660px;font-size:17px;line-height:1.7;color:var(--muted);")}
                >
                  No. BrandBase sits beneath your stack. We read from what you already run — Snowflake, NielsenIQ, Circana, retailer portals, ad platforms, your CRM and ERP — and BrandBase is MCP-ready, so the AI tools your teams already use can work off the same governed foundation.
                </p>
              </>
            ) : null}
          </div>
          <div style={s("border-top:1px solid var(--line);")}>
            {' '}
            <button
              type="button"
              onClick={v.toggle3}
              style={s("width:100%;background:none;border:none;padding:26px 4px;display:flex;align-items:flex-start;gap:20px;text-align:left;cursor:pointer;")}
            >
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;color:var(--mint);padding-top:5px;min-width:20px;")}
              >
                3
              </span>
              {' '}
              <span
                style={s("flex:1;font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(17px,1.9vw,21px);letter-spacing:-0.02em;color:var(--text);")}
              >
                How long until we see something real?
              </span>
              {' '}
              <span style={s("font-size:22px;line-height:1;color:var(--mint);padding-top:2px;")}>
                {v.sign3}
              </span>
              {' '}
            </button>
            {' '}
            {v.open3 ? (
              <>
                <p
                  style={s("margin:0 4px 28px 44px;max-width:660px;font-size:17px;line-height:1.7;color:var(--muted);")}
                >
                  Weeks, not quarters. A design partnership starts bounded: we connect a first set of sources and stand up one workflow — usually the weekly business review — so your team is running something real before the engagement widens.
                </p>
              </>
            ) : null}
          </div>
          <div style={s("border-top:1px solid var(--line);")}>
            {' '}
            <button
              type="button"
              onClick={v.toggle4}
              style={s("width:100%;background:none;border:none;padding:26px 4px;display:flex;align-items:flex-start;gap:20px;text-align:left;cursor:pointer;")}
            >
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;color:var(--mint);padding-top:5px;min-width:20px;")}
              >
                4
              </span>
              {' '}
              <span
                style={s("flex:1;font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(17px,1.9vw,21px);letter-spacing:-0.02em;color:var(--text);")}
              >
                Who does the work — my team or yours?
              </span>
              {' '}
              <span style={s("font-size:22px;line-height:1;color:var(--mint);padding-top:2px;")}>
                {v.sign4}
              </span>
              {' '}
            </button>
            {' '}
            {v.open4 ? (
              <>
                <p
                  style={s("margin:0 4px 28px 44px;max-width:660px;font-size:17px;line-height:1.7;color:var(--muted);")}
                >
                  Ours builds, yours steers. We do the connector and agent work; your team brings the questions, definitions, and judgment calls that make the output trustworthy. Expect a few hours a week from a small core group during the build.
                </p>
              </>
            ) : null}
          </div>
          <div style={s("border-top:1px solid var(--line);")}>
            {' '}
            <button
              type="button"
              onClick={v.toggle5}
              style={s("width:100%;background:none;border:none;padding:26px 4px;display:flex;align-items:flex-start;gap:20px;text-align:left;cursor:pointer;")}
            >
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;color:var(--mint);padding-top:5px;min-width:20px;")}
              >
                5
              </span>
              {' '}
              <span
                style={s("flex:1;font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(17px,1.9vw,21px);letter-spacing:-0.02em;color:var(--text);")}
              >
                Will our data train your models?
              </span>
              {' '}
              <span style={s("font-size:22px;line-height:1;color:var(--mint);padding-top:2px;")}>
                {v.sign5}
              </span>
              {' '}
            </button>
            {' '}
            {v.open5 ? (
              <>
                <p
                  style={s("margin:0 4px 28px 44px;max-width:660px;font-size:17px;line-height:1.7;color:var(--muted);")}
                >
                  Never. Your data is kept isolated per client, never pooled, and never used to train shared models. Syndicated sources are used strictly within your licensing terms, and we'll confirm the exact terms in writing during onboarding.
                </p>
              </>
            ) : null}
          </div>
          <div style={s("border-top:1px solid var(--line);border-bottom:1px solid var(--line);")}>
            {' '}
            <button
              type="button"
              onClick={v.toggle6}
              style={s("width:100%;background:none;border:none;padding:26px 4px;display:flex;align-items:flex-start;gap:20px;text-align:left;cursor:pointer;")}
            >
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;color:var(--mint);padding-top:5px;min-width:20px;")}
              >
                6
              </span>
              {' '}
              <span
                style={s("flex:1;font-family:'Sofia Pro',sans-serif;font-weight:700;font-size:clamp(17px,1.9vw,21px);letter-spacing:-0.02em;color:var(--text);")}
              >
                Does AI replace analysts on our team?
              </span>
              {' '}
              <span style={s("font-size:22px;line-height:1;color:var(--mint);padding-top:2px;")}>
                {v.sign6}
              </span>
              {' '}
            </button>
            {' '}
            {v.open6 ? (
              <>
                <p
                  style={s("margin:0 4px 28px 44px;max-width:660px;font-size:17px;line-height:1.7;color:var(--muted);")}
                >
                  No — that's the point. BrandBase takes the assembling, exporting, and reconciling off your team's plate so analysts and brand leads spend their time on the interpretation and the decision. AI should let teams flourish, not thin them out.
                </p>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
}
